import type { StorageArea } from "../../storageAreas/domain/storageArea";

export function useSearchProduct(productId: string, storageAreas: StorageArea[]) {

  let foundStorageAreaIds: Set<string> = new Set();

  const filteredStorageAreas = storageAreas
  .filter(storageAreas => storageAreas.logYardData?.content
  .some(product => product.productId == productId),
  );

  filteredStorageAreas.forEach((storageArea) => {
    foundStorageAreaIds.add(storageArea.id);
  });

  return foundStorageAreaIds;
}
